import { render, staticRenderFns } from "./blockedComponent.vue?vue&type=template&id=41da9220&scoped=true"
import script from "./blockedComponent.vue?vue&type=script&lang=js"
export * from "./blockedComponent.vue?vue&type=script&lang=js"
import style0 from "./blockedComponent.vue?vue&type=style&index=0&id=41da9220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41da9220",
  null
  
)

export default component.exports